// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G679","toggle":"styles_toggle__2x8km","preview":"styles_preview__1eeiF"};